
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`In verschiedenen Studien hat sich gezeigt, dass bei Migränikern der
Magnesiumspiegel im Hirn niedriger ist als bei Nicht-Migränikern. Es gibt aber
nur wenig Beweise, dass die Einnahme dieses Mineralstoffs gegen die
Kopfschmerzen hilft. Eine Dosis von 10 Millimol pro Tag half den Patienten in
einer Studie an Kopfschmerzzentren jedenfalls nicht. 24 Millimol täglich dagegen
nützten bei Patienten in allgemeinmedizinischen Praxen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;